import md5 from "md5";

function encryptMd5(message = "") {
  return md5(message);
}

export default encryptMd5;
